export default "__VITE_ASSET__CMeXtF$t__"